/* __next_internal_client_entry_do_not_use__ IMPORT_STATUS,useIsImport auto */import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { detectClientEnvironment } from "@/util";
export var IMPORT_STATUS;
(function (IMPORT_STATUS) {
  IMPORT_STATUS["INIT"] = "init";
  IMPORT_STATUS["YES"] = "yes";
  IMPORT_STATUS["NO"] = "No";
})(IMPORT_STATUS || (IMPORT_STATUS = {}));
// 判断是否需要走导流逻辑
export const useIsImport = () => {
  const [importStatus, setImportStatus] = useState("init");
  useEffect(() => {
    (async () => {
      if (isMobile) {
        const {
          canAccessInternet
        } = await detectClientEnvironment();
        if (canAccessInternet) {
          setImportStatus("yes");
        } else {
          setImportStatus("No");
        }
      } else {
        setImportStatus("No");
      }
    })();
  }, []);
  return {
    importStatus
  };
};